import { Horizontal } from "Components/Horizontal";
import { HorizontalError } from "Components/HorizontalError";
import * as DateFns from "date-fns";
import { Dropdown } from "Inputs/Dropdown";
import React from "react";
import { range } from "Tools";
import { useFormikContext } from "formik";
import { CreditCardInput } from "Inputs/CreditCardInput";
import { CreditCardInputProps } from "SharedConstants/Schema";

export function CreditCardAndExpDateInput(_: CreditCardInputProps) {
  const { errors } = useFormikContext<any>();
  const now = new Date();
  return (
    <>
      <Horizontal isRequired label="Credit Card">
        <CreditCardInput
          fieldName="FullCreditCardNumber"
          placeholder="Credit Card Number"
        />
      </Horizontal>
      <Horizontal isRequired label="Expiration">
        <Dropdown
          fieldName="ExpirationDateMonth"
          options={range(0, 12).map(month =>
            DateFns.format(new Date(2000, month, 1), "MM - MMMM"),
          )}
          placeholder="Select a month..."
          handleMeta={() => undefined}
        />
        <Dropdown
          fieldName="ExpirationDateYear"
          options={range(
            DateFns.getYear(now),
            DateFns.getYear(DateFns.addYears(now, 15)),
          ).map(e => e.toString())}
          placeholder="Select a year..."
          handleMeta={() => undefined}
        />
      </Horizontal>
      <HorizontalError>{errors["CC_EXP_DATE"]}</HorizontalError>
    </>
  );
}
